import React from 'react';
import moment from 'moment';
import { formatDateAndTime } from '../../../function/Helper';

interface IProps {
  checkInInfo: any;
}

const SpecificCheckInDetails = (props: IProps) => {
  const { checkInInfo } = props;

  return (
    <div className="xl:h-[calc(100vh-264px)] flex flex-col gap-3 p-2 xl:p-4 overflow-y-auto">
      <div className="flex gap-4">
        <label className="text-xs md:text-sm text-white font-bold">Register Date</label>
        <label className="text-xs md:text-sm text-white font-normal">
          {/* {moment(checkInInfo.createdAt).local().format('L')} */}
          {formatDateAndTime(checkInInfo.createdAt)}
        </label>
      </div>

      <div className="flex gap-[66px]">
        <label className="text-xs md:text-sm text-white font-bold">Name</label>
        <label className="text-xs md:text-sm text-white font-normal break-all">
          {checkInInfo.name}
        </label>
      </div>

      <div className="flex gap-[70px]">
        <label className="text-xs md:text-sm text-white font-bold">Email</label>
        <label className="text-xs md:text-sm text-white font-normal">{checkInInfo.email}</label>
      </div>

      <div className="flex gap-[66px]">
        <label className="text-xs md:text-sm text-white font-bold">Phone</label>
        <label className="text-xs md:text-sm text-white font-normal">{checkInInfo.phone}</label>
      </div>
    </div>
  );
};

export default SpecificCheckInDetails;
